import { render, staticRenderFns } from "./XMas24SpecialView.vue?vue&type=template&id=424a2cce"
import script from "./XMas24SpecialView.vue?vue&type=script&lang=ts"
export * from "./XMas24SpecialView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports